<template>
  <img
    @click="$router.push('/')"
    alt="Snitch"
    class="logo"
    :style="{ width }"
    src="/assets/logo/white.full.svg"
  />
</template>

<script>
export default {

  props: {
    width: {
      type: String,
      default: '7rem'
    }
  },

  methods: {
    goHome() {
      this.$router.push({ name: 'dashboard' })
    },
  },

}
</script>
